@layer component {
  /* BASE ------------------------------------------------------------------- */

  .flex {
    display: flex;
  }

  /* DISPLAY ---------------------------------------------------------------- */

  .displayFlex {
    width: 100%;
  }

  .displayInlineFlex {
    display: inline-flex;
  }

  /* DIRECTION -------------------------------------------------------------- */

  .row {
    flex-direction: row;
  }

  .rowReverse {
    flex-direction: row-reverse;
  }

  .column {
    flex-direction: column;
  }

  .columnReverse {
    flex-direction: column-reverse;
  }

  /* WRAP ------------------------------------------------------------------- */

  .wrap {
    flex-wrap: wrap;
  }

  .wrapReverse {
    flex-wrap: wrap-reverse;
  }

  .noWrap {
    flex-wrap: nowrap;
  }

  /* ALIGN ITEMS ------------------------------------------------------------ */

  .alignItemsCenter {
    align-items: center;
  }

  .alignItemsFlexStart {
    align-items: flex-start;
  }

  .alignItemsFlexEnd {
    align-items: flex-end;
  }

  .alignItemsBaseline {
    align-items: baseline;
  }

  .alignItemsStretch {
    align-items: stretch;
  }

  /* JUSTIFY CONTENT -------------------------------------------------------- */

  .justifyContentCenter {
    justify-content: center;
  }

  .justifyContentFlexStart {
    justify-content: flex-start;
  }

  .justifyContentFlexEnd {
    justify-content: flex-end;
  }

  .justifyContentSpaceBetween {
    justify-content: space-between;
  }

  .justifyContentSpaceAround {
    justify-content: space-around;
  }

  .justifyContentSpaceEvenly {
    justify-content: space-evenly;
  }

  /* GROW / SHRINK ---------------------------------------------------------- */

  .grow0 {
    flex-grow: 0;
  }
  .grow1 {
    flex-grow: 1;
  }
  .shrink0 {
    flex-shrink: 0;
  }
  .shrink1 {
    flex-shrink: 1;
  }

  /* CONTAINER -------------------------------------------------------------- */

  .isContainer {
    container-type: inline-size;
  }

  /* GAP, MARGIN, & PADDING ARE HANDLED BY UTILITY CLASSES ------------------ */
}
